import {isEmpty} from 'lodash';

export default (inputOptions) => {
    const options = {...inputOptions};
    if (isEmpty(options.key)) {
        throw new Error('You need to provide an api key.');
    }
    return options;
};



// WEBPACK FOOTER //
// ./map/configurer/initializeTierOptions.js